var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewDevice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_379_4150)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 24H5.625C2.52338 24 0 21.4766 0 18.375V5.625C0 2.52338 2.52338 0 5.625 0H18.375C21.4766 0 24 2.52338 24 5.625V10.3125C23.9505 11.5564 22.1741 11.5554 22.125 10.3125V5.625C22.125 3.55725 20.4427 1.875 18.375 1.875H5.625C3.55725 1.875 1.875 3.55725 1.875 5.625V18.375C1.875 20.4427 3.55725 22.125 5.625 22.125H10.5C11.7439 22.1745 11.7429 23.9509 10.5 24ZM15.3281 5.15625C15.3281 4.63847 14.9084 4.21875 14.3906 4.21875H9.60938C8.3655 4.26825 8.36644 6.04467 9.60938 6.09375H14.3906C14.9084 6.09375 15.3281 5.67403 15.3281 5.15625ZM24 17.6719C24 14.1825 21.1612 11.3438 17.6719 11.3438C9.27637 11.6914 9.27961 23.6539 17.6719 24C21.1612 24 24 21.1612 24 17.6719ZM22.125 17.6719C22.125 20.1273 20.1273 22.125 17.6719 22.125C11.7639 21.8803 11.7662 13.4623 17.6719 13.2188C20.1273 13.2188 22.125 15.2164 22.125 17.6719ZM19.3594 16.7344H18.6094V15.9844C18.5599 14.7405 16.7835 14.7414 16.7344 15.9844V16.7344H15.9844C14.7405 16.7839 14.7414 18.5603 15.9844 18.6094H16.7344V19.3594C16.7839 20.6033 18.5603 20.6023 18.6094 19.3594V18.6094H19.3594C20.6033 18.5599 20.6023 16.7835 19.3594 16.7344Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_379_4150"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDevice);
export default __webpack_public_path__ + "static/media/new-device.526a447845652eea4e5194888ac576f5.svg";
export { ForwardRef as ReactComponent };